
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from './components/home/Home'
import Events from './routes/Events'
import Sponsors from './components/sponsors/Sponsors';
// import About from './routes/About'
// import Contact from './routes/Contact'
import About from './components/about/About'
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"
import Page4 from './components/Page4'
import SideBar from './components/sidebar/SideBar'
const App = () => {
  return (

    <>
      <Router>

        <Navbar />
        <SideBar />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/projects" element={<Events />}></Route>
          <Route path="/sponsors" element={<Sponsors />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/gallery" element={<Page4 />}>/</Route>
          {/* <Route path="/about" element={<About />}></Route> */}
          {/* <Route path="/contact" element={<Contact />}></Route> */}
        </Routes>

      </Router>

      <Footer />
    </>


  );
}


export default App;
